'use client';

import { Box, Stack } from '@mantine/core';
import { Bets } from '../Bets';
import { BigWin } from '../WinLastes';
import { CasinoCategory } from './CasinoCategory';
import { CasinoGameList } from './CasinoGameList';
import { CasinoSearch } from './CasinoSearch';
export const CasinoChildPage: React.FC = () => {
  // const primes = games.find((item) => item.id === 'primes')
  return <>
      <BigWin />
      <Stack my={{
      base: 36,
      sm: 40
    }} justify="center" align="center">
        <Box w={{
        base: '100%',
        sm: '90%'
      }}>
          <CasinoSearch />
        </Box>
      </Stack>
      <CasinoCategory />

      <CasinoGameList />

      <Bets hasActionTab />
    </>;
};